import React, { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import arrowRight from "../assets/images/bet-frenzy/arrowRight.svg";
import arrowLeft from "../assets/images/bet-frenzy/arrowLeft.svg";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useNavigate } from "react-router-dom";
import { getDreamCasinoGames } from "../redux/slices/games/casino/dreamCasinoGameListSlice";

export default function GameCarousel({ setIsPopupOpen, setSelectedGame }) {
  const carouselRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [current, setCurrent] = useState(0);
  const [isLeftDisabled, setIsLeftDisabled] = useState(true);
  const [isRightDisabled, setIsRightDisabled] = useState(false);
  const [count, setCount] = useState(0);
  const { data: profileData } = useSelector((state) => state.getProfile);
  const [isLoading, setIsLoading] = useState(true);

  const scrollAmount = 250;

  const scroll = (direction) => {
    if (!carouselRef.current) return;
    if (direction == "left" && isLeftDisabled) return;
    if (direction == "right" && isRightDisabled) return;

    carouselRef.current.scrollBy({
      left: direction == "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    getData(1);
  }, []);

  useEffect(() => {
    const container = carouselRef.current;
    if (!container) return;

    const handleScroll = () => {
      const scrollLeft = container.scrollLeft;
      const maxScrollLeft = container.scrollWidth - container.clientWidth;

      setIsLeftDisabled(scrollLeft <= 5);
      setIsRightDisabled(scrollLeft >= maxScrollLeft - 5);
    };

    container.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, [categories]);

  const getData = (pageNumber) => {
    setIsLoading(true);
   
    dispatch(
      getDreamCasinoGames({
        page: pageNumber,
        limit: 10,
        perpage: 20,
        search_by_category: "instant",
        search_by_provider: "",
        search_by_text: "",
        is_popular: 0,
        parent_user_id: profileData?.user?.parent_user_id,
      })
    )
      .unwrap()
      .then((res) => {
        setCount(res.totalCount);

        const validatedGames = res?.data?.map((game) => ({
          ...game,
          isBroken: false, // flag for broken thumbnails
        }));

        validatedGames?.forEach((game, idx) => {
          const img = new Image();
          img.src = game?.url_thumb;

          img.onload = () => {
            setCategories((prev) => {
              const copy = [...prev];
              copy[idx] = { ...game, isBroken: false }; // ✅ valid image
              return copy;
            });
          };

          img.onerror = () => {
            setCategories((prev) => {
              const copy = [...prev];
              copy[idx] = { ...game, isBroken: true }; // ❌ broken → mark
              return copy;
            });
          };
        });
        // setCategories(res.data);
      })
      .catch((error) => {
        console.error("Failed :", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <div
        className="carousel-container instant-div-desktop"
        style={{ borderRadius: "1rem" }}
      >
        <div className="carousel-header">
          <h4 className="fw-medium hero-heading text-capitalize color-CCD6F6 fs-20">
            Instant Games
          </h4>
          <div className="d-flex">
            {" "}
            <span
              className="see-all align-content-center"
              onClick={() => {
                navigate("/instant-game-list");
              }}
            >
              See all
              <span className="ms-2 text-gray">({count})</span>
            </span>
            {/* Left arrow with disabled handling */}
            <span
              className={`nav-btn-ft mx-1 left d-flex justify-content-center align-items-center ${
                isLeftDisabled ? "disabled-arrow" : ""
              }`}
              onClick={() => scroll("left")}
              style={{ cursor: isLeftDisabled ? "not-allowed" : "pointer" }}
            >
              {/* <GoArrowLeft size={22} /> */}
              <img
                src={arrowLeft}
                width={15}
                alt="Left Arrow"
                style={{ filter: isLeftDisabled ? "grayscale(100%)" : "none" }}
                loading="lazy"
              />
            </span>
            {/* Right arrow with disabled handling */}
            <span
              className={`nav-btn-ft mx-1 right d-flex justify-content-center align-items-center ${
                isRightDisabled ? "disabled-arrow" : ""
              }`}
              onClick={() => scroll("right")}
              style={{ cursor: isRightDisabled ? "not-allowed" : "pointer" }}
            >
              <img
                src={arrowRight}
                width={15}
                alt="Right Arrow"
                style={{ filter: isRightDisabled ? "grayscale(100%)" : "none" }}
                loading="lazy"
              />
              {/* <GoArrowRight size={22} /> */}
            </span>
          </div>
        </div>
        <div className="carousel-wrapper justify-content-center">
          <div className="carousel casino-home-wrap" ref={carouselRef}>
            {isLoading ? (
              <SkeletonTheme baseColor="#2a2d3e" highlightColor="#3e4259">
                {[...Array(6)].map((_, i) => (
                  <div className="d-block" key={i}>
                    <Skeleton
                      height={158}
                      width={238}
                      style={{
                        borderRadius: "10px",
                        margin: "5px",
                      }}
                    />
                  </div>
                ))}
              </SkeletonTheme>
            ) : categories?.length > 0 ? (
              categories?.map((game, index) => (
                
                 
                  <img
                    className="game-card cursor-pointer"
                    draggable="false"
                    src={game?.url_thumb}
                    alt={game?.game_name}
                    onClick={() => {
                      if (profileData) {
                        setSelectedGame(game);
                        setIsPopupOpen(true);
                        // navigate("/game-launch", {
                        //   state: { game_id: game?._id, game: game },
                        // });
                      } else {
                        navigate("/");
                        sessionStorage.setItem("fromLogin", "true");
                      }
                    }}
                    style={{
                      minHeight: "160px",
                      height: "160px",
                      border: game?.isBroken
                        ? "1px solid #3a3f5c"
                        : "1px solid transparent",
                      borderRadius: game?.isBroken ? "10px" : "10px",
                      alignContent: game?.isBroken ? "center" : "",
                      background: game?.isBroken
                        ? "rgba(245, 247, 250, 0.12)"
                        : "",
                      objectFit: "fill",
                    }}
                    loading="lazy"
                  />
                
              ))
            ) : (
              <span className="d-flex  align-items-center text-white">
                No Data Found
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="instant-div-mobile text-center">
        <h4 className="fw-medium hero-heading text-uppercase my-3 text-green ">
          <span className="text-green">Instant</span> Games
        </h4>
        <div
          className="fs-14 text-gray text-center mx-2 mx-sm-2 mx-md-3 mx-lg-4 mx-xl-4 instant-des"
          style={{ marginBottom: "10px" }}
        >
          {/* marginLeft: "8rem" , marginRight: "8rem", */}
          Enjoy the funny, dazzling environment of mini games. Try your luck and
          find out how fortunate you are
        </div>

        <div className="text-center">
          {categories?.length > 0 && (
            <img
              src={categories[current]?.url_thumb}
              alt={categories[current]?.game_name}
              className="m-auto p-2 w-100"
              style={{
                objectFit: "contain",
                borderRadius: "30px",
                border: categories[current]?.isBroken
                  ? "1px solid #3a3f5c"
                  : "none",
                minHeight: categories[current]?.isBroken ? "210px" : "210px",
                minWidth: categories[current]?.isBroken
                  ? "-webkit-fill-available"
                  : "",
                display: categories[current]?.isBroken ? "block" : "",
                alignContent: categories[current]?.isBroken ? "center" : "",
                background: categories[current]?.isBroken
                  ? "rgba(245, 247, 250, 0.12)"
                  : "",
                color: "#fff",
              }}
              loading="lazy"
            />
          )}
        </div>

        <div className="position-relative">
          <MultiImageSlider
            categories={categories}
            setCurrent={setCurrent}
            from={"instant-game"}
            setIsPopupOpen={setIsPopupOpen}
            setSelectedGame={setSelectedGame}
          />
        </div>
      </div>
    </>
  );
}

const MultiImageSlider = ({
  categories,
  setCurrent,
  from,
  setIsPopupOpen,
  setSelectedGame,
}) => {
  const [slidesToShow, setSlidesToShow] = useState(1);
  const imageWidth = 180;
  const { data: profileData } = useSelector((state) => state.getProfile);

  const navigate = useNavigate();

  useEffect(() => {
    const updateSlides = () => {
      const screenWidth = window.innerWidth;

      const count = Math.floor(screenWidth / imageWidth);
      setSlidesToShow(count > 0 ? count : 1);
    };

    updateSlides();
    window.addEventListener("resize", updateSlides);
    return () => window.removeEventListener("resize", updateSlides);
  }, []);

  const settings = {
    infinite: true,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: true,
    pauseOnHover: false,
    cssEase: "ease-in-out",
    swipe: true,
    swipeToSlide: true,
    draggable: true,
    touchMove: true,

    beforeChange: (oldIndex, newIndex) => {
      setCurrent(newIndex);
    },
  };

  return (
    <>
      <Slider {...settings} className="mb-5">
        {categories?.slice(0, 10).map((game, index) => (
          <div className="m-1" key={index}>
            <img
              src={game?.url_thumb}
              alt={game?.game_name}
              className=" instant-game-mobile m-2 p-0"
              onClick={() => {
                if (profileData) {
                  setSelectedGame(game);
                  setIsPopupOpen(true);
                  // navigate("/game-launch", {
                  //   state: { game_id: game?._id, game: game },
                  // });
                } else {
                  navigate("/");
                  sessionStorage.setItem("fromLogin", "true");
                }
              }}
              style={{
                width: from == "instant-game" ? "150px" : "160px",
                height: "110px",
                border: game?.isBroken
                  ? "1px solid #3a3f5c"
                  : "1px solid transparent",
                borderRadius: game?.isBroken ? "20px" : "20px",
                display: game?.isBroken ? "block" : "block",
                alignContent: game?.isBroken ? "center" : "",
                background: game?.isBroken ? "rgba(245, 247, 250, 0.12)" : "",
                color: "#fff",
                objectFit: "fill",
              }}
              loading="lazy"
            />
          </div>
        ))}
      </Slider>
      <div>
        <span
          className="see-all mb-3 fs-12 d-flex text-start"
          onClick={() => {
            navigate("/instant-game-list");
          }}
        >
          View All
          <span className="ms-2 text-gray">({categories?.length})</span>
        </span>
      </div>
    </>
  );
};
